export class RecipientSelectionEntity {
    id;
    title;
    identifierType;
    identifierId;
    identifierName;

    constructor(id, title, identifierType, identifierId, identifierName) {
        this.id = id;
        this.title = title;
        this.identifierType = identifierType;
        this.identifierId = identifierId;
        this.identifierName = identifierName;
    }
};